import { useTranslation } from "react-i18next";
import { PlusIcon } from "@heroicons/react/20/solid";
import {generate} from "../../../routing/routes";

export default function NewTripLight() {
    const { t } = useTranslation();

    return (
        <div
            onClick={()=>{
                window.open(generate('book'), '_blank')
            }}
            className={
                "group mt-8 flex h-40 w-full cursor-pointer items-center rounded-lg border-2 border-dashed border-gray-300 text-center " +
                "hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            }
        >
            <PlusIcon className="h-20 w-20 text-orange-300 group-hover:text-orange-500" />
            <div
                className={
                    "text-lg font-medium text-gray-400  group-hover:text-gray-500 lg:text-xl"
                }
            >
                {t('account_button.create_trip')}
            </div>
        </div>
    );
}
